// src/components/GroupSwitcherSheet.js
import { useState } from "react";
import {
  Box,
  ButtonBase,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import CheckIcon from "@mui/icons-material/Check";

const GOLD = "#D4AF37";
const MINT = "#4CAF82";

const GROUP_NAME_SX = { fontWeight: 700, fontSize: { xs: "1.3rem", md: "2.125rem" } };

export default function GroupSwitcherSheet({ activeGroupId, activeGroupName, primaryGroupId, memberships, onSwitch }) {
  const [open, setOpen] = useState(false);

  if (!activeGroupName) return null;

  if (memberships.length < 2) {
    return <Typography variant="h4" sx={GROUP_NAME_SX}>{activeGroupName}</Typography>;
  }

  const handleSelect = (groupId) => {
    setOpen(false);
    if (groupId !== activeGroupId) {
      onSwitch(groupId);
    }
  };

  return (
    <>
      <ButtonBase
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        sx={{ display: "block", textAlign: "left", borderRadius: 2, px: 1, mx: -1 }}
      >
        <Typography variant="h4" sx={GROUP_NAME_SX}>{activeGroupName}</Typography>
        <Typography
          variant="caption"
          sx={{ display: "block", mt: -0.5, color: MINT, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em" }}
        >
          Tap to switch group
        </Typography>
      </ButtonBase>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            pb: 1,
          },
        }}
      >
        <Box sx={{ width: 36, height: 4, borderRadius: 999, bgcolor: "divider", mx: "auto", mt: 1.5, mb: 1 }} />
        <Typography variant="overline" sx={{ px: 2, color: "text.secondary" }}>
          Switch Group
        </Typography>
        <List>
          {memberships.map((m) => {
            const groupId = m.group_id;
            const isActive = groupId === activeGroupId;
            const isPrimary = groupId === primaryGroupId;
            return (
              <ListItemButton
                key={groupId}
                selected={isActive}
                onClick={() => handleSelect(groupId)}
                sx={{ "&.Mui-selected": { bgcolor: "rgba(76,175,130,0.12)" }, "&.Mui-selected:hover": { bgcolor: "rgba(76,175,130,0.18)" } }}
              >
                <ListItemIcon sx={{ minWidth: 32, color: GOLD }}>
                  {isPrimary && <StarIcon fontSize="small" />}
                </ListItemIcon>
                <ListItemText primary={m.groups?.name} />
                {isActive && <CheckIcon fontSize="small" sx={{ color: MINT }} />}
              </ListItemButton>
            );
          })}
        </List>
      </Drawer>
    </>
  );
}
